import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useNavigate, useParams } from 'react-router-dom';
import { colors } from '../../config/constants';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';
import Dailog from '../../components/Dailog/Dailog';
import Dropdown from '../../components/Dropdown/Dropdown';
import { keyword, successMessage } from '../../config/keyword';
import Keywords from './Keywords/Keywords';
import Bulkupload from './Keywords/Bulkupload';
import { StateProps } from '../../redux/reducer';
import { Role } from '../../config/enum';
import Tabs from '../../components/Tabs/Tabs';

type CatgoryResponseProps = {
  name: string;
  organizationId: string;
  id: string;
  categoryLabelId: string;
  categoryLabelName: string;
  keywordCount: number;
  isActive: boolean | null;
};
const CategoryDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [isEdit, setIsEdit] = useState(false);
  const [activeTab, setActiveTab] = useState(keyword.DETAILS);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [state, setState] = useState<CatgoryResponseProps>({
    name: '',
    organizationId: '',
    id: '',
    categoryLabelId: '',
    categoryLabelName: '',
    keywordCount: 0,
    isActive: null,
  });
  const [categoryLabel, setCategoryLable] = useState([]);
  const [category, setCategory] = useState<CatgoryResponseProps>({
    name: '',
    organizationId: '',
    id: '',
    categoryLabelId: '',
    categoryLabelName: '',
    keywordCount: 0,
    isActive: null,
  });
  const { name, categoryLabelName, categoryLabelId, isActive } = category;

  const tabObj = [
    {
      label: keyword.DETAILS,
      onPress: () => {
        setActiveTab(keyword.DETAILS);
      },
    },
    {
      label: keyword.KEYWORD,
      onPress: () => {
        setActiveTab(keyword.KEYWORD);
      },
    },
    {
      label: keyword.BULK_UPLOAD,
      onPress: () => {
        setActiveTab(keyword.BULK_UPLOAD);
      },
    },
  ];

  useEffect(() => {
    const breadcrumb = [
      { path: '/categories', name: 'Categories' },
      { path: `/categoryDetails/${id}`, name: 'Category Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getCategoryLable();
  }, []);

  useEffect(() => {
    if (activeTab === keyword.DETAILS) {
      getCategories();
    }
  }, [activeTab]);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateCategory();
    }
  }, [formError]);

  const handleUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const validation = () => {
    const error: any = {};
    if (!name) {
      error.name = errorMessage.emptyCategory;
    } else if (name.length <= 2 || name.length > 128) {
      error.name = errorMessage.categoryLength;
    }
    if (!categoryLabelId) {
      error.categoryLabelId = errorMessage.emptyCategoryLabel;
    }
    return error;
  };

  const getCategories = () => {
    dispatch(updateIsLoading(true));
    instance
      .get(`/categories/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));

        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: CatgoryResponseProps) => {
    setCategory(data);
    setState(data);
    dispatch(updateIsLoading(false));
  };

  const handleEdit = () => {
    setIsEdit(!isEdit);
  };

  const getCategoryLable = () => {
    instance
      .get(`/category-labels`)
      .then((response) => {
        if (response.status === 200) {
          setCategoryLable(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateCategory = () => {
    const obj = {
      name: name,
      categoryLabelId: categoryLabelId,
    };
    dispatch(updateIsLoading(true));
    instance
      .put(`/categories/${category.id}`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CATEGORY_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getCategories();
          setIsEdit(false);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        setIsEdit(false);
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const handleChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setCategory({ ...category, [event.target.name]: event.target.value });
    if (event.target.name === 'name') {
      if (event.target.value !== '') {
        setFormError({ ...formError, [event.target.name]: undefined });
      } else {
        setFormError({
          ...formError,
          name: `Category is required`,
        });
      }
    }
    if (event.target.name === 'categoryLabelId') {
      if (event.target.value !== '') {
        setFormError({ ...formError, [event.target.name]: undefined });
      } else {
        setFormError({
          ...formError,
          categoryLabelId: `Category label is required`,
        });
      }
    }
  };

  const handleUpdateCancel = () => {
    getCategories();
    setIsEdit(false);
    setIsSubmit(false);
    setFormError({});
  };

  const onCategoryDelete = () => {
    dispatch(updateIsLoading(true));
    instance
      .delete(`/categories/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CATEGORY_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));

          setIsDeletePopup(false);
          setTimeout(() => {
            navigate('/categories');
          }, 1000);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const handleActiveInactive = (status: boolean) => {
    dispatch(updateIsLoading(true));
    instance
      .put(`/categories/${id}/status/${status}`)
      .then((response) => {
        if (response.status === 200) {
          if (status === true) {
            const obj = {
              isOpen: true,
              message: successMessage.CATEGORY_ACTIVATE,
              type: flashBarTheme.SUCCESS,
            };
            dispatch(updateFlashBar(obj));
          } else {
            const obj = {
              isOpen: true,
              message: successMessage.CATEGORY_DEACTIVATE,
              type: flashBarTheme.SUCCESS,
            };
            dispatch(updateFlashBar(obj));
          }
          getCategories();
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const handleCategoryLabel = (label: string) => {
    if (label === null || label === undefined || label === '') {
      return '-';
    } else if (label.length > 30) {
      return label.substring(0, 29) + '...';
    } else {
      return label;
    }
  };
  return (
    <div className="px-2">
      <PageHeading label="Category Details" />
      <div
        className={`bg-white rounded-sm justify-between ${colors.primaryText} p-2`}
      >
        <Tabs obj={tabObj} activeTab={activeTab} activeKey={'NoKey'} />

        {activeTab === keyword.DETAILS && (
          <>
            <div className="p-2">
              <div
                className={`flex flex-col justify-between ${colors.primaryText} p-2 bg-white rounded-xl px-4`}
              >
                <div className="sm:flex text-md mb-2">
                  <div className={`sm:w-1/3 `}>Category Name</div>
                  {isEdit ? (
                    <div className="-my-1">
                      <Input
                        placeholder={'Enter Category'}
                        type={'text'}
                        value={category.name}
                        name="name"
                        onChange={(event) => {
                          handleChangeText(event);
                        }}
                        error={formError?.name}
                      />
                    </div>
                  ) : (
                    <div className=" text-black flex sm:w-2/4 ">
                      <div>{name}</div>
                    </div>
                  )}
                </div>
                <div className="sm:flex text-md mb-2">
                  <div className={`sm:w-1/3 `}>Category Label</div>
                  {isEdit ? (
                    <div className="-my-1">
                      <Dropdown
                        name={'categoryLabelId'}
                        value={categoryLabelId}
                        onChange={(event) => handleChangeText(event)}
                        error={formError?.categoryLabelId}
                        initialOption={{
                          name: 'Select Label',
                          id: '',
                        }}
                        options={categoryLabel}
                      />
                    </div>
                  ) : (
                    <div className="text-black flex sm:w-2/4 ">
                      <div>{categoryLabelName}</div>
                    </div>
                  )}
                </div>
                <div className="sm:flex text-md mb-2">
                  <div className={`sm:w-1/3 `}>Total Keywords</div>

                  <div className=" text-black flex sm:w-2/4 ">
                    <div>{category.keywordCount}</div>
                  </div>
                </div>
                {userInfo.role !== Role.User && (
                  <>
                    {isEdit ? (
                      <div className="flex justify-end gap-2">
                        <Button
                          label="Update"
                          buttonType="primary"
                          type="button"
                          onClick={() => handleUpdate()}
                          disabled={
                            state.name === name &&
                            state.categoryLabelId === categoryLabelId
                          }
                        />
                        <Button
                          label="Cancel"
                          buttonType="danger"
                          type="button"
                          onClick={() => handleUpdateCancel()}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-end mt-2 space-x-2">
                        <Button
                          label="Edit"
                          buttonType="primary"
                          type="button"
                          onClick={() => handleEdit()}
                        />

                        <Button
                          label={`${isActive === true ? 'Deactivate' : 'Activate'}`}
                          buttonType="primary"
                          type="button"
                          onClick={() =>
                            handleActiveInactive(isActive === true ? false : true)
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            {userInfo.role !== Role.User && (
              <div className="flex justify-center pb-2 ">
                <Button
                  label="Delete Category"
                  buttonType="danger"
                  type="button"
                  onClick={() => setIsDeletePopup(true)}
                />
                <Dailog
                  isDeletePopup={isDeletePopup}
                  setIsPopupOpen={setIsDeletePopup}
                  title={'Category'}
                  onConfirm={() => {
                    onCategoryDelete();
                  }}
                />
              </div>
            )}
          </>
        )}
        {activeTab === keyword.KEYWORD && (
          <Keywords
            categoryId={id as string}
            isActive={isActive}
            category={category}
          />
        )}
        {activeTab === keyword.BULK_UPLOAD && (
          <Bulkupload
            categoryName={name}
            categoryLabelName={categoryLabelName}
            isActive={isActive}
          />
        )}
      </div>
    </div>
  );
};

export default CategoryDetails;
